module.exports = __webpack_public_path__ + "static/media/boulevard_bzid.40bae1b6.png";